import React from 'react'
import { SvgIcon } from '@material-ui/core'

function HierarchyHideIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Subtract'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10.5988 11.4814H6.90489C6.44651 11.4814 6.07492 11.853 6.07492 12.3114V14.6514H4.82997C4.37159 14.6514 4 15.023 4 15.4813V19.4468C4 19.9051 4.37159 20.2767 4.82997 20.2767H8.79539C9.25377 20.2767 9.62536 19.9051 9.62536 19.4468V15.4813C9.62536 15.023 9.25377 14.6514 8.79539 14.6514H7.31988V12.7264H11.8437L10.5988 11.4814ZM15.533 14.6514H16.4496V12.7264H13.608L11.2622 10.3806V9.32555H10.2072L9.07205 8.19043V4.53017C9.07205 4.07178 9.44364 3.7002 9.90202 3.7002H13.8674C14.3258 3.7002 14.6974 4.07179 14.6974 4.53017V8.49558C14.6974 8.95397 14.3258 9.32555 13.8674 9.32555H12.5072V11.4814H16.8645C17.3229 11.4814 17.6945 11.853 17.6945 12.3114V14.6514H19.17C19.6284 14.6514 20 15.023 20 15.4813V19.1184L18.755 17.8734V15.8963H16.7779L15.533 14.6514ZM14.3988 15.2815C14.383 15.3455 14.3746 15.4125 14.3746 15.4813V19.4468C14.3746 19.9051 14.7462 20.2767 15.2046 20.2767H19.17C19.2389 20.2767 19.3058 20.2683 19.3698 20.2525L18.1491 19.0318H15.6196V16.5023L14.3988 15.2815ZM10.317 8.0806V4.94515H13.4525V8.0806H10.317ZM5.24496 19.0318V15.8963H8.3804V19.0318H5.24496Z'
      />
      <path
        id='Line 10 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.8464 5.85355C5.04166 5.65829 5.35824 5.65829 5.5535 5.85355L20.5535 20.8536C20.7488 21.0488 20.7488 21.3654 20.5535 21.5607C20.3582 21.7559 20.0417 21.7559 19.8464 21.5607L4.8464 6.56066C4.65114 6.3654 4.65114 6.04882 4.8464 5.85355Z'
      />
      <path
        id='Line 10 (Stroke) (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.77569 5.78266C5.01 5.54835 5.3899 5.54835 5.62422 5.78266L20.6242 20.7827C20.8585 21.017 20.8585 21.3969 20.6242 21.6312C20.3899 21.8655 20.01 21.8655 19.7757 21.6312L4.77569 6.63119C4.54137 6.39688 4.54137 6.01698 4.77569 5.78266ZM5.48279 5.92408C5.32658 5.76787 5.07332 5.76787 4.91711 5.92408C4.7609 6.08029 4.7609 6.33356 4.91711 6.48977L19.9171 21.4898C20.0733 21.646 20.3266 21.646 20.4828 21.4898C20.639 21.3336 20.639 21.0803 20.4828 20.9241L5.48279 5.92408Z'
      />
    </SvgIcon>
  )
}

export default HierarchyHideIcon
